// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-main-inner .my-custom-quill-editor-email-input .ql-toolbar.ql-snow + .ql-container.ql-snow {\n  height: 100px;\n  resize: vertical;\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
